import "../DatePicker.css";
import Picker from "react-datepicker";
import DateHeader from "../DateHeader/DateHeader";
import { ChangeEvent, useState } from "react";
import { InputProps } from "../../Input/Input";
import { DateInput } from "../DateInput/DateInput";
import { Container, weekDayMap } from "../helpers";
import { CalendarTheme } from "../enum";

type InputDatePickerProps = {
  theme?: CalendarTheme;
  date?: Date;
  setDate: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  showTimePicker?: boolean;
  edit?: boolean;
};

const dateFormat = "dd/MM/yyyy";

const InputDatePicker = ({
  theme = CalendarTheme.Primary,
  date,
  setDate,
  minDate = new Date("1900-01-01"),
  maxDate = new Date("2100-12-31"),
  showTimePicker = false,
  edit = true,
  ...props
}: InputProps & InputDatePickerProps) => {
  const [time, setTime] = useState("");

  const handleTimeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTime(e.target.value);
    const [hour, minute] = e.target.value.split(":");
    if (!date || !hour || !minute) return;

    const updated = new Date(date);
    updated.setHours(Number(hour), Number(minute));
    setDate(updated);
  };

  const customInput = (
    <DateInput
      data-testid="input-date-picker-custom-input"
      {...(showTimePicker && {
        timeProps: {
          disabled: !date,
          value: time,
          onChange: handleTimeChange,
        },
      })}
      {...props}
      autoComplete="off"
    />
  );

  const renderWeekDay = (day: string) => <div>{weekDayMap[day]}</div>;

  const handleChange = (newDate: Date | null) => {
    if (newDate) setDate(newDate);
  };

  return (
    <div data-testid="input-date-picker">
      <Picker
        minDate={minDate ?? undefined}
        maxDate={maxDate ?? undefined}
        selected={date ?? null}
        dateFormat={dateFormat}
        strictParsing
        enableTabLoop={false}
        popperPlacement="bottom-end"
        calendarClassName={CalendarTheme[theme].toLowerCase()}
        calendarContainer={Container}
        renderCustomHeader={DateHeader(edit, minDate ?? undefined, maxDate ?? undefined, date)}
        onChange={handleChange}
        formatWeekDay={renderWeekDay}
        customInput={customInput}
        placeholderText={props?.placeholder}
        disabled={props?.disabled}
        calendarStartDay={1}
      />
    </div>
  );
};

export default InputDatePicker;
